// Angular Imports
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
// Shared Imports
import { EColor, EFontSize, EIconSize, EIcons } from '@shared/models'
import { IconComponent } from '../../icons/icon/icon.component'
import { IDriverTileComposedValue } from '@dashboard/modules/drivers/models'

enum ETileType {
	normal = 'normal',
	filled = 'filled',
}

@Component({
	standalone: true,
	selector: 'app-tile-square',
	imports: [IconComponent],
	templateUrl: './tile-square.component.html',
	styleUrls: ['./tile-square.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileSquareComponent {
	readonly ETileType = ETileType

	readonly name = input.required<string>()
	readonly value = input<string>()
	readonly composedValue = input<IDriverTileComposedValue | null>(null)
	readonly color = input<keyof typeof EColor>(EColor.greenOne)
	readonly fontSize = input<keyof typeof EFontSize>(EFontSize.headingOne)
	readonly fontSizeLabel = input<keyof typeof EFontSize>(EFontSize.headingThree)
	readonly type = input<keyof typeof ETileType>(ETileType.normal)
	readonly icon = input<EIcons>(EIcons.circleUserSolid)
	readonly iconSize = input<keyof typeof EIconSize>(EIconSize.normal)
	readonly uppercase = input<boolean>(false)

	readonly displayLines = computed(() => {
		const { values = [], extraValues = [] } = this.composedValue() ?? {}
		const filled = (v: string) => ((s) => s !== '' && s !== '-')(v?.trim() ?? '')
		const main = values.filter(filled)
		const extra = extraValues.filter(filled)
		return main.length || extra.length
			? [
					...main.map((t) => ({ text: t, small: false })),
					...extra.map((t) => ({ text: t, small: true })),
				]
			: [{ text: '-', small: false }]
	})
}
